export default {
  TIME_FORMAT: 'timeFormat',
  TOKEN: 'token',
  COUNTRY_ID: 'countryId',
  CURRENCY_ID: 'currencyId',
  USER_ID: 'userId',
  GA: '_ga',
};
